import WeightListItem from "./WeightListItem"
import '../styles/WeightList.css'

const WeightList = ({ weightList, onDelete, weightUnit, onEditWeight }) => {
  return (
    <div className='weightList'>
      {weightList.map((weightListItem) => (<WeightListItem key={weightListItem.date} date={weightListItem.date} weight={weightListItem.weight} onDelete={onDelete} weightUnit={weightUnit} onEditWeight={onEditWeight}/>))}
    </div>
  )
}

export default WeightList